import { SxProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import LoaderAnimation from './LoaderAnimation'
import ProgressBar from './ProgressBar'

// ----------------------------------------------------------------------
// The boot screen.
//
// It covers the viewport, so it is only correct when there is nothing on screen
// worth keeping: the first load, and signing out. Once the sidebar exists,
// covering it makes a route change look like the application restarting.
// `ContentLoading` is the one for that, and a lint rule keeps this component
// out of `src/pages`.
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  // `inset`, not `right` alone. With only `right` set, `top` resolves to the
  // element's static position, so the panel started wherever it happened to be
  // mounted and ran a matching distance off the bottom of the window.
  inset: 0,
  zIndex: 99999,
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}))

type Props = {
  sx?: SxProps
}

const LoadingScreen = ({ ...other }: Props) => {
  return (
    <>
      <ProgressBar />

      {/* The sweep in `scripts/previewShots.mjs` waits for this to go before it
          takes a picture, so a screenshot is never of the boot screen. */}
      <RootStyle
        data-app-loading=""
        role="status"
        aria-label="Loading"
        aria-busy="true"
        {...other}
      >
        <LoaderAnimation />
      </RootStyle>
    </>
  )
}

export default LoadingScreen
